import React from 'react'

import { BorderedRadioButton } from 'slab'
import { checkIfEnrollmentIsReimbursementOnly } from 'utils/reimbursement_utils'
import { type BrokersEnrollmentWithPaymentsOrCoverages } from 'utils/web_api.schemas'

import CopyButton from '../reusable/CopyButton'

export interface ReimbursementEnrollmentSelectionsProps {
  onChange: ((v: string) => void)
  enrollments: BrokersEnrollmentWithPaymentsOrCoverages[]
  selectedEnrollmentId?: string
  selectedTransactionDate?: string
}

export const ReimbursementEnrollmentSelections: React.FC<ReimbursementEnrollmentSelectionsProps> = ({ onChange, enrollments, selectedEnrollmentId, selectedTransactionDate }) => {
  return (
    <>
      {enrollments.map((enrollment) => (
        <BorderedRadioButton
          key={enrollment.id}
          label={enrollment.title}
          checked={selectedEnrollmentId === enrollment.id}
          onChange={() => onChange(enrollment.id)}
        >
          {selectedTransactionDate && (
            <div className='body-sm text-gray-500 group-disabled:text-opacity-30'>
              Reimbursement Only: {checkIfEnrollmentIsReimbursementOnly(enrollment, selectedTransactionDate) ? 'Yes' : 'No'}
            </div>
          )}
          <div className='flex items-center body-sm text-gray-500 group-disabled:text-opacity-30 gap-2'>
            Enrollment: {enrollment.id}
            <CopyButton valueToCopy={enrollment.id} />
          </div>
          <div className='body-sm text-gray-500 group-disabled:text-opacity-30'>
            Type: {enrollment.category}
          </div>
          <div className='body-sm text-gray-500 group-disabled:text-opacity-30'>
            Monthly Premium: {enrollment.monthly_premium}
          </div>
          <div className='body-sm text-gray-500 group-disabled:text-opacity-30'>
            Coverage Start Date: {enrollment.coverage_start_date}
          </div>
          <div className='body-sm text-gray-500 group-disabled:text-opacity-30'>
            Coverage End Date: {enrollment.coverage_end_date}
          </div>
        </BorderedRadioButton>
      ))}
    </>
  )
}
